/* eslint-disable jsx-a11y/alt-text */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import SearchBar from "../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Button,
    TextField,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import EditCategoryCommission from "../../Modals/editCategoryCommission";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const CommissionBySubscription = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const commissioncategorydata = [
        { id: "CAT001", name: "Electronics Category", rate: 8 },
        { id: "CAT002", name: "Fashion Category", rate: 15 },
        { id: "CAT003", name: "Handmade & Artisan", rate: 10 },
        { id: "CAT004", name: "New Vendor Rate", rate: 5 },
    ];
    const [open, setOpen] = useState(false);
    const handleCloseModal = () => {
        setOpen(false);
    };
    return (
        <>
            <div className="main_title">
                <h1> Commissions by Subsription</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -<button onClick={() => navigate("/commissions")}>Commissions</button> -  Commissions by Subscription
                </p>
            </div>
            <div className="stats_boxes gap_m">

                {/* TOTAL STRUCTURES */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            8
                            <p>Total Categories</p>
                        </h2>
                        <figure className="blue">
                            <AccountTreeOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight info">
                        <span>Configured</span>
                        <small>across platform</small>
                    </div>
                </div>

                {/* ACTIVE STRUCTURES */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            8
                            <p>Active Categories</p>
                        </h2>
                        <figure className="sucess">
                            <CheckCircleOutlineIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight positive">
                        <span>100%</span>
                        <small>activation rate</small>
                    </div>
                </div>

                {/* AVG COMMISSION RATE */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            9.4%
                            <p>Avg Commission Rate</p>
                        </h2>
                        <figure className="warning">
                            <PercentOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight info">
                        <span>Optimized</span>
                        <small>across categories</small>
                    </div>
                </div>
            </div>

            <div className="cards mt_20">
                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search categories..."
                            />
                        </Box>
                    </div>

                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => setOpen(true)}><AddIcon />Add Commission</Button>
                    </div>
                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No</TableCell>
                                <TableCell>Category Name</TableCell>
                                <TableCell>Rate</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {commissioncategorydata.map((item, index) => (
                                <TableRow key={item.id} hover>
                                    {/* Sr No */}
                                    <TableCell>{index + 1}</TableCell>

                                    {/* Category Name */}
                                    <TableCell>
                                        <b>{item.name}</b>
                                    </TableCell>

                                    {/* Rate */}
                                    <TableCell>{item.rate}%</TableCell>

                                    {/* Actions */}
                                    <TableCell >
                                        <div className="table_actions v2">
                                            <IconButton
                                                onClick={() => setOpen(true)}
                                            >
                                                <img src="/static/images/edit2_icon.svg" />
                                            </IconButton>

                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>



            <EditCategoryCommission open={open} onClose={handleCloseModal} setOpen={setOpen} />

        </>
    )
};
export default CommissionBySubscription;